function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "fi-rr-lock",
  transform: "translate(-2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4258",
  "data-name": "Path 4258",
  d: "M14.042,5.967V4.958a4.958,4.958,0,1,0-9.917,0V5.967A3.542,3.542,0,0,0,2,9.208v4.25A3.546,3.546,0,0,0,5.542,17h7.083a3.546,3.546,0,0,0,3.542-3.542V9.208A3.542,3.542,0,0,0,14.042,5.967Zm-8.5-1.009a3.542,3.542,0,1,1,7.083,0v.708H5.542Zm9.208,8.5a2.125,2.125,0,0,1-2.125,2.125H5.542a2.125,2.125,0,0,1-2.125-2.125V9.208A2.125,2.125,0,0,1,5.542,7.083h7.083A2.125,2.125,0,0,1,14.75,9.208Z",
  fill: "#f6c244"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4259",
  "data-name": "Path 4259",
  d: "M12,14a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V15A1,1,0,0,0,12,14Z",
  transform: "translate(-2.917 -4.9)",
  fill: "#f6c244"
}));

var SvgReset = function SvgReset(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.167,
    height: 17,
    viewBox: "0 0 14.167 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReset, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reset.8e0b24eb.svg";
export { ForwardRef as ReactComponent };